// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict, List } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetDepth (params?: {}): Promise<Dict>;
    publicGetOrders (params?: {}): Promise<List>;
    publicGetTicker (params?: {}): Promise<Dict>;
    publicGetTickers (params?: {}): Promise<Dict>;
    privatePostBalance (params?: {}): Promise<Dict>;
    privatePostOrderHistory (params?: {}): Promise<List>;
    privatePostTradeAdd (params?: {}): Promise<Dict>;
    privatePostTradeCancel (params?: {}): Promise<Dict>;
    privatePostTradeList (params?: {}): Promise<List>;
    privatePostTradeView (params?: {}): Promise<Dict>;
    privatePostWallet (params?: {}): Promise<Dict>;
    webApiGetAjaxCoinCoinInfo (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
